class Accordion {
  
  /*
  elements = {
      container: HTML element,
      tab_selector: string,
      tab_content_selector: string
  }
  */

  constructor(elements) {
    this.elements = elements;
    this.init();
  }
  
  init() {
    const control = this.elements.container.querySelector(this.elements.tab_selector);
    const target = this.elements.container.querySelector(this.elements.tab_content_selector);

    control.addEventListener('click', event => {
      event.preventDefault();
      if (!control.matches('.accordion-open')) {
        control.classList.add('accordion-open');
        target.classList.add('accordion-open');
      } else {
        control.classList.remove('accordion-open');
        target.classList.remove('accordion-open');
      }
    });
  }
}
  
export default Accordion;


// WEBPACK FOOTER //
// ./src/js/widgets/Accordion.js